module.exports = __webpack_public_path__ + "static/media/volunteer.c95d0533.png";